import {
    getJWTHeaders,
    getHeaderNoAuth,
    getLoginFormHeader,
    isAuthenticated
} from "../common/server";
import StorageManager from "./StorageManager.service";
import jwtDecode from "jwt-decode";

class APIService {
    baseUrl = process.env.REACT_APP_SERVER_URL
    userMail = null;

    levelCache = {};
    poolCache = {};

    constructor() {
        if (isAuthenticated()) {
            this.userMail = StorageManager.getUserMail();
        }
    }

    async getCourses(params) {
        let fetchUrl = this.baseUrl + '/course/filter';
        if (params) {
            fetchUrl += "?";
            Object.keys(params).forEach(key => {
                fetchUrl += `${key}=${params[key]}&`;
            });
        }

        fetchUrl = fetchUrl.charAt(fetchUrl.length - 1) === "&" ? fetchUrl.substring(0, fetchUrl.length - 1) : fetchUrl;
        console.log("Params: " + fetchUrl);
        return fetch(fetchUrl, {
            method: "GET",
            headers: getHeaderNoAuth(),
        }).then(res => this.handleFetchResponse(res));
    }

    async getCourseById(id) {
        return fetch(`${this.baseUrl}/course/${id}`, {
            method: "GET",
            headers: getHeaderNoAuth(),
        }).then(res => this.handleFetchResponse(res));
    }

    async login(email, password) {
        const config = {
            username: email,
            password: password
        };

        let response = await fetch(`${this.baseUrl}/login`, {
            method: 'POST',
            headers: getLoginFormHeader(),
            body: new URLSearchParams({
                "username": config.username,
                "password": config.password
            })
        });

        if (response.ok) {
            try {
                let data = await response.json();
                if (data.token != null) {
                    StorageManager.storeJWTToken(data.token);
                    let decodedJwtMail = jwtDecode(data.token).email;
                    StorageManager.storeUserMail(decodedJwtMail);
                    this.userMail = decodedJwtMail;
                    return 200;
                } else {
                    return 500;
                }
            } catch (erro) {
                return 302;
            }
        } else if (response.status === 400) {
            return 400;
        } else if (response.status === 500) {
            return 500;
        }
    }

    async getParticipantByUserId() {
        return fetch(`${this.baseUrl}/participant/user/${this.userMail}`, {
            method: "GET",
            headers: getJWTHeaders()
        }).then(res => this.handleFetchResponse(res));
    }

    async createUser(params) {
        return fetch(`${this.baseUrl}/user/create`, {
            method: "POST",
            headers: getHeaderNoAuth(),
            body: JSON.stringify(params)
        });
    }

    async getUserDataFromId() {
        return fetch(`${this.baseUrl}/userdata/user/${this.userMail}`, {
            method: "GET",
            headers: getJWTHeaders(),
        }).then(res => this.handleFetchResponse(res));
    }

    async getUserInfoFromId() {
        return fetch(`${this.baseUrl}/user/${this.userMail}`, {
            method: "GET",
            headers: getJWTHeaders(),
        }).then(res => this.handleFetchResponse(res));
    }

    async getLevelList() {
        return fetch(`${this.baseUrl}/course/level`, {
            method: "GET",
            headers: getHeaderNoAuth(),
        }).then(res => this.handleFetchResponse(res));
    }

    async createPartecipant(params) {
        return fetch(`${this.baseUrl}/participant/create`, {
            method: "POST",
            headers: getJWTHeaders(),
            body: JSON.stringify(params)
        }).then(res => this.handleFetchResponse(res));
    }

    async deleteParticipantById(id) {
        return fetch(`${this.baseUrl}/participant/${id}`, {
            method: "DELETE",
            headers: getJWTHeaders(),
        });
    }

    async updateUserData(params) {
        return fetch(`${this.baseUrl}/user/update/${this.userMail}`, {
            method: "PUT",
            headers: getJWTHeaders(),
            body: JSON.stringify(params)
        }).then(res => this.handleFetchResponse(res));
    }

    async getBookedCourseByUser() {
        return fetch(`${this.baseUrl}/bookcourse/user/${this.userMail}`, {
            method: "GET",
            headers: getJWTHeaders(),
        }).then(res => this.handleFetchResponse(res));
    }

    async getParticipantById(participantId) {
        return fetch(`${this.baseUrl}/participant/${participantId}`, {
            method: "GET",
            headers: getJWTHeaders()
        }).then(res => this.handleFetchResponse(res));
    }

    async editParticipantInfo(params, participantId) {
        return fetch(`${this.baseUrl}/participant/${participantId}`, {
            method: "PUT",
            headers: getJWTHeaders(),
            body: JSON.stringify(params)
        }).then(res => this.handleFetchResponse(res));
    }

    async editDatiProfilo(params) {
        return fetch(`${this.baseUrl}/user/update/${this.userMail}`, {
            method: "PUT",
            headers: getJWTHeaders(),
            body: JSON.stringify(params)
        }).then(res => this.handleFetchResponse(res));
    }

    async resetPassword(email) {
        return fetch(`${this.baseUrl}/user/resetPassword`, {
            method: "POST",
            headers: getLoginFormHeader(),
            body: new URLSearchParams({
                "email": email
            })
        });
    }

    async setNewPassword(password, token) {
        return fetch(`${this.baseUrl}/user/setPassword?${new URLSearchParams({ token: token })}`, {
            method: "PUT",
            headers: getHeaderNoAuth(),
            body: JSON.stringify(password)
        }).then(res => this.handleFetchResponse(res));
    }

    async deleteUserProfile() {
        return fetch(`${this.baseUrl}/user/${this.userMail}`, {
            method: "DELETE",
            headers: getJWTHeaders()
        }).then(res => this.handleFetchResponse(res));
    }

    async getUserOrderInfo() {
        return fetch(`${this.baseUrl}/basket/user/${this.userMail}`, {
            method: "GET",
            headers: getJWTHeaders()
        }).then(res => this.handleFetchResponse(res));
    }

    async getUserCouponInfo() {
        return fetch(`${this.baseUrl}/coupon/user/${this.userMail}`, {
            method: "GET",
            headers: getJWTHeaders()
        }).then(res => this.handleFetchResponse(res));
    }

    async createUserData(params) {
        return fetch(`${this.baseUrl}/userdata/create`, {
            method: "POST",
            headers: getJWTHeaders(),
            body: JSON.stringify(params)
        }).then(res => this.handleFetchResponse(res));
    }

    async editUserData(params, userDataId) {
        return fetch(`${this.baseUrl}/userdata/${userDataId}`, {
            method: "PUT",
            headers: getJWTHeaders(),
            body: JSON.stringify(params)
        });
    }

    async getPoolById(piscinaId) {
        if (this.poolCache[piscinaId]) {
            return Promise.resolve(this.poolCache[piscinaId]);
        }

        return fetch(`${this.baseUrl}/piscina/${piscinaId}`, {
            method: "GET",
            headers: getHeaderNoAuth(),
        }).then(res => this.handleFetchResponse(res))
          .then(data => {
              this.poolCache[piscinaId] = data;
              return data;
          });
    }

    async getLuogoPiscineList() {
        return fetch(`${this.baseUrl}/piscina`, {
            method: "GET",
            headers: getHeaderNoAuth()
        }).then(res => this.handleFetchResponse(res));
    }

    async getBasketData() {
        return fetch(`${this.baseUrl}/basket/theothercreate`, {
            method: "POST",
            headers: getJWTHeaders()
        }).then(res => this.handleFetchResponse(res));
    }

    async getBasketDataAll(pageSize) {
        return fetch(`${this.baseUrl}/basket?pageSize=${pageSize}&query=Completed`, {
            method: "GET",
            headers: getJWTHeaders()
        }).then(res => this.handleFetchResponse(res));
    }

    async getBasketDetailById(basketId) {
        return fetch(`${this.baseUrl}/basket/${basketId}`, {
            method: "GET",
            headers: getJWTHeaders()
        }).then(res => this.handleFetchResponse(res));
    }

    async getUserInfoFromEmailAdmin(email) {
        return fetch(`${this.baseUrl}/user/${email}`, {
            method: "GET",
            headers: getJWTHeaders()
        }).then(res => this.handleFetchResponse(res));
    }

    async createAdminCourse(courseData) {
        return fetch(`${this.baseUrl}/admin/course/create`, {
            method: "POST",
            headers: getJWTHeaders(),
            body: JSON.stringify(courseData)
        }).then(res => this.handleFetchResponse(res));
    }

    async editAdminCourse(payload, courseId) {
        return fetch(`${this.baseUrl}/admin/course/${courseId}`, {
            method: "PUT",
            headers: getJWTHeaders(),
            body: JSON.stringify(payload)
        }).then(res => this.handleFetchResponse(res));
    }

    async createAdminDaysForCourse(dayData) {
        return fetch(`${this.baseUrl}/day/createfromlist`, {
            method: "POST",
            headers: getJWTHeaders(),
            body: JSON.stringify(dayData)
        }).then(res => this.handleFetchResponse(res));
    }

    async deleteCourse(id) {
        return fetch(`${this.baseUrl}/admin/course/${id}`, {
            method: "DELETE",
            headers: getJWTHeaders()
        }).then(res => this.handleFetchResponse(res));
    }

    async getLevelById(levelCourseId) {
        if (this.levelCache[levelCourseId]) {
            return Promise.resolve(this.levelCache[levelCourseId]);
        }

        return fetch(`${this.baseUrl}/course/level/${levelCourseId}`, {
            method: "GET",
            headers: getHeaderNoAuth()
        }).then(res => this.handleFetchResponse(res))
          .then(data => {
              this.levelCache[levelCourseId] = data;
              return data;
          });
    }

    async getDaysForCourse(id) {
        return fetch(`${this.baseUrl}/day/course/${id}`, {
            method: "GET",
            headers: getHeaderNoAuth()
        }).then(res => this.handleFetchResponse(res));
    }

    async createLevel(payload) {
        this.levelCache = {};
        return fetch(`${this.baseUrl}/course/level/create`, {
            method: "POST",
            headers: getJWTHeaders(),
            body: JSON.stringify(payload)
        }).then(res => this.handleFetchResponse(res));
    }

    async editLevel(payload, id) {
        this.levelCache = {};
        return fetch(`${this.baseUrl}/course/level/${id}`, {
            method: "PUT",
            headers: getJWTHeaders(),
            body: JSON.stringify(payload)
        }).then(res => this.handleFetchResponse(res));
    }

    async deleteLevel(id) {
        this.levelCache = {};
        return fetch(`${this.baseUrl}/course/level/${id}`, {
            method: "DELETE",
            headers: getJWTHeaders()
        }).then(res => {
            if (!res.ok) {
                return Promise.reject({status: res.status, ok: res.ok});
            }
            return res.json().catch(() => ({}));
        });
    }

    async getAllPools(pageSize) {
        return fetch(`${this.baseUrl}/piscina?pageSize=${pageSize}`, {
            method: "GET",
            headers: getHeaderNoAuth()
        }).then(res => this.handleFetchResponse(res));
    }

    async createPool(payload) {
        this.poolCache = {};
        return fetch(`${this.baseUrl}/piscina/create`, {
            method: "POST",
            headers: getJWTHeaders(),
            body: JSON.stringify(payload)
        }).then(res => this.handleFetchResponse(res));
    }

    async editPool(payload, id) {
        this.poolCache = {};
        return fetch(`${this.baseUrl}/piscina/${id}`, {
            method: "PUT",
            headers: getJWTHeaders(),
            body: JSON.stringify(payload)
        }).then(res => this.handleFetchResponse(res));
    }

    async deletePool(id) {
        this.poolCache = {};
        return fetch(`${this.baseUrl}/piscina/${id}`, {
            method: "DELETE",
            headers: getJWTHeaders()
        }).then(res => {
            if (!res.ok) {
                return Promise.reject({status: res.status, ok: res.ok});
            }
            return res.json().catch(() => ({}));
        });
    }

    async createBookCourse(data) {
        return fetch(`${this.baseUrl}/bookcourse/create`, {
            method: "POST",
            headers: getJWTHeaders(),
            body: JSON.stringify(data)
        }).then(res => this.handleFetchResponse(res));
    }

    async createBasket(baskedPayload) {
        return fetch(`${this.baseUrl}/basket/create`, {
            method: "POST",
            headers: getJWTHeaders(),
            body: JSON.stringify(baskedPayload)
        }).then(res => this.handleFetchResponse(res));
    }

    async deleteBookCourse(bookcourseId) {
        return fetch(`${this.baseUrl}/bookcourse/${bookcourseId}`, {
            method: "DELETE",
            headers: getJWTHeaders()
        }).then(res => this.handleFetchResponse(res));
    }

    async payCartAndPlaceOrder(basket) {
        return fetch(`${this.baseUrl}/transaction/payment`, {
            method: "POST",
            headers: getJWTHeaders(),
            body: JSON.stringify(basket)
        }).then(res => this.handleFetchResponse(res));
    }

    async getAdminParticipantForCourse(courseId) {
        return fetch(`${this.baseUrl}/admin/course/participants/${courseId}`, {
            method: "GET",
            headers: getJWTHeaders(),
        }).then(res => this.handleFetchResponse(res));
    }

    async createCoupon(couponData) {
        return fetch(`${this.baseUrl}/coupon/create`, {
            method: "POST",
            headers: getJWTHeaders(),
            body: JSON.stringify(couponData)
        }).then(res => this.handleFetchResponse(res));
    }

    async getAllCoupons(pageSize) {
        return fetch(`${this.baseUrl}/coupon?pageSize=${pageSize}`, {
            method: "GET",
            headers: getJWTHeaders(),
        }).then(res => this.handleFetchResponse(res));
    }

    async getCouponById(couponId) {
        return fetch(`${this.baseUrl}/coupon/${couponId}`, {
            method: "GET",
            headers: getJWTHeaders(),
        }).then(res => this.handleFetchResponse(res));
    }

    async deleteCoupon(id) {
        return fetch(`${this.baseUrl}/coupon/${id}`, {
            method: "DELETE",
            headers: getJWTHeaders(),
        }).then(res => this.handleFetchResponse(res));
    }

    async linkCouponToBasket(code, basketId) {
        return fetch(`${this.baseUrl}/coupon/basket/${code}?basketId=${basketId}`, {
            method: "POST",
            headers: getJWTHeaders(),
        }).then(res => this.handleFetchResponse(res));
    }

    async deleteDayById(dayId) {
        return fetch(`${this.baseUrl}/day/${dayId}`, {
            method: "DELETE",
            headers: getJWTHeaders(),
        }).then(res => this.handleFetchResponse(res));
    }

    async createDayForCourse(payload) {
        return fetch(`${this.baseUrl}/day/create`, {
            method: "POST",
            headers: getJWTHeaders(),
            body: JSON.stringify(payload)
        }).then(res => this.handleFetchResponse(res));
    }

    async getReportAllParticipantFromTo(from, to) {
        return fetch(`${this.baseUrl}/admin/report/participants?from=${from}&to=${to}`, {
            method: "GET",
            headers: getJWTHeaders(),
        });
    }

    async getReportPartnerOffer() {
        return fetch(`${this.baseUrl}/admin/report/partnerOffer`, {
            method: "GET",
            headers: getJWTHeaders(),
        });
    }

    async getReportNewsLetter() {
        return fetch(`${this.baseUrl}/admin/report/newsletter`, {
            method: "GET",
            headers: getJWTHeaders(),
        });
    }

    async getReportTransaction(from, to) {
        return fetch(`${this.baseUrl}/admin/report/transactions?from=${from}&to=${to}`, {
            method: "GET",
            headers: getJWTHeaders(),
        });
    }

    async getPoolImageById(id) {
        return fetch(`${this.baseUrl}/piscina/image?id=${id}`, {
            method: "GET",
            headers: getHeaderNoAuth(),
        });
    }

    async getLevelImageById(id) {
        return fetch(`${this.baseUrl}/course/level/image?id=${id}`, {
            method: "GET",
            headers: getHeaderNoAuth(),
        });
    }

    async getAdminBasket(pageSize) {
        return fetch(`${this.baseUrl}/admin/basket?pageSize=${pageSize}&query=Completed`, {
            method: "GET",
            headers: getJWTHeaders(),
        }).then(res => this.handleFetchResponse(res));
    }

    handleFetchResponse(res) {
        if (res.ok) {
            return res.json().catch(() => {
                return Promise.reject({
                    status: res.status,
                    ok: res.ok,
                    message: "",
                    body: ""
                });
            });
        } else {
            return Promise.reject({
                status: res.status,
                ok: res.ok,
                message: "",
                body: res.body
            });
        }
    }
}

export default new APIService();
